export enum ToastType {
  Info = 'info',
  Urgent = 'urgent',
}
